"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAlert = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var __1 = require("../../");
var common_1 = require("../../../common");
require("./GKAlert.css");
/**
 * Alerts are used to give the user immediate, temporary feedback on an action. All alerts contain a close button,
 * and they can be made to time out automatically after a short period of time. Alerts can be wrapped in a
 * GKAlertsContainer (recommended), to control global vs local appearance.
 */
var GKAlert = function (props) {
    var _a;
    var persistentId = (0, common_1.usePersistentId2)();
    var uniqueId = (_a = props.id) !== null && _a !== void 0 ? _a : persistentId;
    var _b = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-alert",
        id: uniqueId,
    }), children = _b.children, color = _b.color, dataQA = _b["data-qa"], _c = _b.dismissible, dismissible = _c === void 0 ? true : _c, icon = _b.icon, isOpen = _b.isOpen, onDismiss = _b.onDismiss, onExited = _b.onExited, timeout = _b.timeout, passthroughProps = __rest(_b, ["children", "color", "data-qa", "dismissible", "icon", "isOpen", "onDismiss", "onExited", "timeout"]);
    var _d = React.useState(false), hasBeenDismissed = _d[0], setHasBeenDismissed = _d[1];
    var _e = React.useState(), alertIcon = _e[0], setAlertIcon = _e[1];
    var dismiss = function () {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        setHasBeenDismissed(true);
    };
    var toggle = dismissible ? dismiss : undefined;
    var transitionProps = {
        mountOnEnter: true,
        onExited: onExited,
        timeout: 150,
        unmountOnExit: true,
    };
    React.useEffect(function () {
        if (timeout) {
            var timer_1 = window.setTimeout(dismiss, timeout);
            return function () { return window.clearTimeout(timer_1); };
        }
        return;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /*
      Handle setting the proper alert icon, based on what "icon" was passed:
        * If false or undefined, the icon should not be displayed
        * If true, set the icon to the default icon for that alert type
        * If GKIconName, use that instead of the default icon
    */
    React.useEffect(function () {
        if (icon === false || !icon) {
            setAlertIcon(undefined);
        }
        else if (icon === true) {
            switch (color) {
                case "info":
                    setAlertIcon(__1.GKIconName.Info);
                    break;
                case "success":
                    setAlertIcon(__1.GKIconName.CheckCircle);
                    break;
                case "danger":
                    setAlertIcon(__1.GKIconName.Error);
                    break;
                case "warning":
                    setAlertIcon(__1.GKIconName.Warning);
                    break;
                case "secondary":
                    setAlertIcon(__1.GKIconName.Help);
                    break;
            }
        }
        else if (icon) {
            setAlertIcon(icon);
        }
    }, [icon, color]);
    return (React.createElement(reactstrap_1.Alert, __assign({}, passthroughProps, { color: color, "data-qa": dataQA, toggle: toggle, transition: transitionProps, isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : !hasBeenDismissed }),
        alertIcon && (React.createElement(__1.GKIcon, { className: "gk-alert-icon", name: alertIcon, "data-qa": dataQA + "--icon" })),
        React.createElement("div", { className: "gk-alert--content", "data-qa": dataQA + "--content" }, children)));
};
exports.GKAlert = GKAlert;
exports.default = exports.GKAlert;
